import { apiGetproductProfit } from "api/reportApi";

import { AmountComponent, PriceComponent, NumberComponent } from "components/Table/CellComponents";

const productProfitColumns = [
    {
        name: "کد حسابداری",
        key: "accountingCode",
        size: "2",
        filterParams: {
            column: "accountingCode",
            columnType: "string",
        },
    },
    {
        name: "دسته بندی",
        key: "Category",
        size: "3",
        searchType: "autocomplete",
        filterParams: {
            column: "Category",
            columnType: "string",
        },
        // disableSearch: true,
    },
    {
        name: "نام",
        key: "title",
        size: "5",
        navigateKey: (item: any) => item.productId,
        navigate: "/reports/productsAccountCard?productId=",
        // disableSearch: true,
        filterParams: {
            column: "title",
            columnType: "string",
        },
    },
    {
        name: "کد کالا",
        key: "code",
        size: "2",
        filterParams: {
            column: "code",
            columnType: "string",
        },
        // disableSearch: true,
    },
    {
        name: "تعداد فروش",
        key: "saleQuantity",
        size: "2",
        Component: AmountComponent,
        searchType: "quantitative",
        filterParams: {
            column: "saleQuantity",
            columnType: "number",
        },
        // disableSearch: true,
    },
    // {
    //     name: "تعداد خرید",
    //     key: "buyQuantity",
    //     size: "2",
    //     Component: AmountComponent,
    //     searchType: "quantitative",
    //     filterParams: {
    //         column: "buyQuantity",
    //         columnType: "number",
    //     },
    //     // disableSearch: true,
    // },
    // {
    //     name: "تخفیف فروش",
    //     key: "saleDiscount",
    //     size: "3",
    //     Component: PriceComponent,
    //     searchType: "quantitative",
    //     filterParams: {
    //         column: "saleDiscount",
    //         columnType: "number",
    //     },
    //     // disableSearch: true,
    // },
    // {
    //     name: "تخفیف خرید",
    //     key: "buyDiscount",
    //     size: "3",
    //     Component: PriceComponent,
    //     searchType: "buyDiscount",
    //     filterParams: {
    //         column: "buyDiscount",
    //         columnType: "number",
    //     },
    //     // disableSearch: true,
    // },
    // {
    //     name: "مالیات فروش",
    //     key: "saleTax",
    //     size: "3",
    //     Component: PriceComponent,
    //     searchType: "quantitative",
    //     filterParams: {
    //         column: "saleTax",
    //         columnType: "number",
    //     },
    //     // disableSearch: true,
    // },
    // {
    //     name: "مالیات خرید",
    //     key: "buyTax",
    //     size: "3",
    //     Component: PriceComponent,
    //     searchType: "quantitative",
    //     filterParams: {
    //         column: "buyTax",
    //         columnType: "number",
    //     },
    //     // disableSearch: true,
    // },
    {
        name: "مبلغ فروش",
        key: "saleAmount",
        size: "3",
        Component: PriceComponent,
        searchType: "quantitative",
        filterParams: {
            column: "saleAmount",
            columnType: "number",
        },
        // disableSearch: true,
    },
    {
        name: "مبلغ خرید",
        key: "buyAmount",
        size: "3",
        Component: PriceComponent,
        searchType: "buyAmount",
        filterParams: {
            column: "buyAmount",
            columnType: "number",
        },
        // disableSearch: true,
    },
    // {
    //     name: "تعداد برگشت فروش",
    //     key: "saleReturnsQuantity",
    //     size: "2",
    //     Component: AmountComponent,
    //     searchType: "quantitative",
    //     filterParams: {
    //         column: "saleReturnsQuantity",
    //         columnType: "number",
    //     },
    //     // disableSearch: true,
    // },
    // {
    //     name: "تعداد برگشت خرید",
    //     key: "buyReturnsQuantity",
    //     size: "2",
    //     Component: AmountComponent,
    //     searchType: "quantitative",
    //     filterParams: {
    //         column: "buyReturnsQuantity",
    //         columnType: "number",
    //     },
    //     // disableSearch: true,
    // },
    // {
    //     name: "مبلغ برگشت فروش",
    //     key: "saleReturnsAmount",
    //     size: "3",
    //     Component: PriceComponent,
    //     searchType: "quantitative",
    //     filterParams: {
    //         column: "saleReturnsAmount",
    //         columnType: "string",
    //     },
    //     // disableSearch: true,
    // },
    // {
    //     name: "مبلغ برگشت خرید",
    //     key: "buyReturnsAmount",
    //     size: "3",
    //     Component: PriceComponent,
    //     searchType: "quantitative",
    //     filterParams: {
    //         column: "buyReturnsAmount",
    //         columnType: "string",
    //     },
    //     // disableSearch: true,
    // },
    {
        name: "میانگین قیمت فروش",
        key: "saleAverage",
        size: "3",
        Component: PriceComponent,
        searchType: "quantitative",
        filterParams: {
            column: "saleAverage",
            columnType: "number",
        },
        // disableSearch: true,
    },
    {
        name: "میانگین قیمت خرید",
        key: "buyAverage",
        size: "3",
        Component: PriceComponent,
        searchType: "quantitative",
        filterParams: {
            column: "buyAverage",
            columnType: "number",
        },
        // disableSearch: true,
    },
    {
        name: "سود کل",
        key: "profitWhole",
        size: "3",
        Component: PriceComponent,
        searchType: "quantitative",
        filterParams: {
            column: "profitWhole",
            columnType: "number",
        },
        // disableSearch: true,
    },
    {
        name: "سود هر واحد فروش",
        key: "profitPerUnit",
        size: "3",
        Component: PriceComponent,
        searchType: "quantitative",
        filterParams: {
            column: "profitPerUnit",
            columnType: "number",
        },
        // disableSearch: true,
    },
    {
        name: "حاشیه سود",
        key: "profitMargin",
        size: "3",
        Component: NumberComponent,
        searchType: "quantitative",
        filterParams: {
            column: "profitPerUnit",
            columnType: "number",
        },
        // disableSearch: true,
    },
];

export const productProfitIndexData = [
    {
        key: "productProfit",
        label: "سود و زیان کالا",
        pluralLabel: "سود و زیان کالا",
        title: "سود و زیان کالا",
        pageTitle: "سود و زیان کالا",
        // pageDescription: "نمایش کالا و خدمات کسب و کار",
        tableColumns: productProfitColumns,
        disableSearch: false,
        actions: {
            back: {},
            fetch: apiGetproductProfit,
            // excel: {},
        },
    },
];
